/* ==========================================================================
   CALMAX — interacciones de UI
   Galería, selector de ofertas y opciones por unidad, acordeones, tabs,
   carrusel de reseñas, sticky CTA, modales y exit intent.
   ========================================================================== */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function toast(message, type) {
    var host = $('[data-toast-host]');
    if (!host) { return; }
    var el = document.createElement('div');
    el.className = 'toast' + (type ? ' toast--' + type : '');
    el.textContent = message;
    host.appendChild(el);
    setTimeout(function () { el.remove(); }, 3000);
  }

  /* ------------------------------------------------------------- galería */
  function initGallery() {
    $$('[data-gallery]').forEach(function (gallery) {
      var main = $('[data-gallery-main]', gallery);
      var thumbs = $$('[data-gallery-thumb]', gallery);

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          main.src = thumb.getAttribute('data-src');
          main.alt = thumb.getAttribute('data-alt') || main.alt;
        });
      });
    });
  }

  /* ------------------------------------------ selector de ofertas (packs) */
  /* Un grupo puede además tener opciones por unidad (color, talle). Se envían
     como propiedades de línea, igual que los `attributes` del export. */
  function initOffers() {
    $$('[data-offers]').forEach(function (group) {
      var offers = $$('[data-offer]', group);
      var button = $(group.getAttribute('data-cart-button-target') || '[data-cart-add]');
      var unitHost = $('[data-unit-options]', group);
      var unitLabel = group.getAttribute('data-unit-label') || 'Unidad';
      var unitIntro = group.getAttribute('data-unit-intro') || '';
      var optionsId = group.getAttribute('data-unit-options-id');
      var gallery = document.querySelector('[data-gallery]');
      var checkStock = group.getAttribute('data-check-stock') === 'true';
      var ctaLabelEl = button ? $('.btn-primary__label', button) : null;
      var ctaLabel = ctaLabelEl ? ctaLabelEl.textContent : '';

      var optionDefs = [];
      if (optionsId) {
        var node = document.getElementById(optionsId);
        if (node) {
          try { optionDefs = JSON.parse(node.textContent) || []; } catch (e) { optionDefs = []; }
        }
      }

      var current = null;
      /* selections[unitIndex][optionName] = valueKey */
      var selections = [];

      function defaultsFor() {
        var row = {};
        optionDefs.forEach(function (def) {
          if (!def.values || !def.values.length) { return; }
          var wanted = def['default'];
          var exists = wanted && def.values.some(function (v) { return v.key === wanted; });
          row[def.name] = exists ? wanted : def.values[0].key;
        });
        return row;
      }

      function valueOf(def, key) {
        for (var i = 0; i < def.values.length; i++) {
          if (def.values[i].key === key) { return def.values[i]; }
        }
        return def.values[0];
      }

      function units() {
        return current ? parseInt(current.getAttribute('data-units') || '1', 10) : 1;
      }

      /* El mapa de variantes viene indexado por la opción que define la
         variante (ej. el color). Se detecta comparando claves. */
      function resolveVariantId(offer) {
        var raw = offer.getAttribute('data-variant-map');
        if (!raw) { return offer.getAttribute('data-variant-id') || ''; }
        var map;
        try { map = JSON.parse(raw); } catch (e) { return ''; }
        var keys = Object.keys(map);
        var driver = optionDefs.filter(function (def) {
          return def.values.every(function (v) { return keys.indexOf(v.key) !== -1; });
        })[0];
        if (!driver || !selections[0]) { return map[keys[0]] || ''; }
        return map[selections[0][driver.name]] || map[keys[0]] || '';
      }

      /* Stock real (inventario de Shopify) del pack seleccionado, indexado
         por key de color. Viene de data-variant-stock, calculado en Liquid
         contra product.variants — no se hardcodea acá qué color está sin
         stock. Ausente cuando show_stock_status está apagado en la sección. */
      function stockMapOf(offer) {
        if (!checkStock || !offer) { return null; }
        var raw = offer.getAttribute('data-variant-stock');
        if (!raw) { return null; }
        try { return JSON.parse(raw); } catch (e) { return null; }
      }

      function driverOptionFor(map) {
        return optionDefs.filter(function (def) {
          return def.values.every(function (v) { return map.hasOwnProperty(v.key); });
        })[0];
      }

      /* Si el color elegido en cualquier unidad del pack activo está sin
         stock, el CTA final pasa a "SIN STOCK" y se deshabilita. Se revisa
         en cada cambio de selección, sin recargar la página. */
      function syncStock() {
        if (!checkStock || !button) { return; }
        var map = stockMapOf(current);
        var outOfStock = false;
        if (map) {
          var driverDef = driverOptionFor(map);
          if (driverDef) {
            for (var i = 0; i < units(); i++) {
              var row = selections[i] || defaultsFor();
              if (map[row[driverDef.name]] === false) { outOfStock = true; break; }
            }
          }
        }
        button.disabled = outOfStock;
        if (ctaLabelEl) { ctaLabelEl.textContent = outOfStock ? 'SIN STOCK' : ctaLabel; }
      }

      function buildProperties() {
        if (!optionDefs.length) { return null; }
        var props = {};
        for (var i = 0; i < units(); i++) {
          var row = selections[i] || defaultsFor();
          props[unitLabel + ' ' + (i + 1)] = optionDefs.map(function (def) {
            return (def.valuePrefix || '') + valueOf(def, row[def.name]).label;
          }).join(' · ');
        }
        return props;
      }

      function syncGallery() {
        if (!gallery || !selections[0]) { return; }
        var def = optionDefs.filter(function (d) {
          return d.values.some(function (v) { return v.gallery && v.gallery.length; });
        })[0];
        if (!def) { return; }
        var value = valueOf(def, selections[0][def.name]);
        if (!value.gallery || !value.gallery.length) { return; }

        var main = $('[data-gallery-main]', gallery);
        var thumbs = $$('[data-gallery-thumb]', gallery);
        if (main) { main.src = value.gallery[0]; }
        thumbs.forEach(function (thumb, i) {
          var url = value.gallery[i];
          thumb.hidden = !url;
          if (!url) { return; }
          thumb.setAttribute('data-src', url);
          var img = thumb.querySelector('img');
          if (img) { img.src = url; }
          thumb.classList.toggle('is-active', i === 0);
        });
      }

      function syncButton() {
        if (!button || !current) { return; }
        button.setAttribute('data-variant-id', resolveVariantId(current));
        button.setAttribute('data-quantity', current.getAttribute('data-quantity') || '1');
        button.setAttribute('data-success-message', (current.getAttribute('data-label') || 'Producto') + ' agregado al carrito');
        var props = buildProperties();
        if (props) {
          button.setAttribute('data-properties', JSON.stringify(props));
        } else {
          button.removeAttribute('data-properties');
        }
      }

      function renderUnits() {
        if (!unitHost || !optionDefs.length) { return; }
        var total = units();
        while (selections.length < total) { selections.push(defaultsFor()); }

        var stockMap = stockMapOf(current);
        var stockDriver = stockMap ? driverOptionFor(stockMap) : null;

        var html = '';
        if (unitIntro) {
          html += '<p class="unit-options__intro">' + unitIntro.replace('{n}', total) + '</p>';
        }

        for (var i = 0; i < total; i++) {
          html += '<div class="unit-row" data-unit-index="' + i + '">';
          if (total > 1) {
            html += '<span class="unit-row__label">' + unitLabel + ' ' + (i + 1) + '</span>';
          }
          var selects = optionDefs.filter(function (d) { return d.style === 'select'; });
          var swatches = optionDefs.filter(function (d) { return d.style !== 'select'; });

          html += '<div class="unit-row__groups">';
          swatches.forEach(function (def) {
            html += '<div class="unit-swatches">';
            def.values.forEach(function (v) {
              var active = selections[i][def.name] === v.key;
              var oos = stockDriver && def === stockDriver && stockMap[v.key] === false;
              html += '<button type="button" class="unit-swatch' + (active ? ' is-active' : '') + (oos ? ' is-outofstock' : '') + '"' +
                ' data-unit-set="' + i + '" data-option="' + escapeAttr(def.name) + '" data-value="' + escapeAttr(v.key) + '"' +
                ' aria-pressed="' + active + '">' +
                '<span class="unit-swatch__dot" style="background:' + (v.swatch || '#eee') + '"></span>' +
                '<span class="unit-swatch__label">' + v.label + '</span>' +
                (oos ? '<span class="unit-swatch__stock">SIN STOCK</span>' : '') +
                '</button>';
            });
            html += '</div>';
          });

          if (selects.length) {
            html += '<div class="unit-row__selects">';
            selects.forEach(function (def) {
              html += '<label class="unit-select"><span>' + def.name + '</span><select data-unit-set="' + i + '" data-option="' + escapeAttr(def.name) + '">';
              def.values.forEach(function (v) {
                var active = selections[i][def.name] === v.key;
                html += '<option value="' + escapeAttr(v.key) + '"' + (active ? ' selected' : '') + '>' + v.label + '</option>';
              });
              html += '</select></label>';
            });
            html += '</div>';
          }

          html += '</div></div>';
        }

        unitHost.innerHTML = html;
      }

      function escapeAttr(str) {
        return String(str == null ? '' : str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
      }

      function select(offer) {
        offers.forEach(function (o) { o.classList.remove('is-selected'); });
        offer.classList.add('is-selected');
        current = offer;
        renderUnits();
        syncButton();
        syncStock();
      }

      offers.forEach(function (offer) {
        offer.addEventListener('click', function () { select(offer); });
      });

      if (unitHost) {
        unitHost.addEventListener('click', function (event) {
          var swatch = event.target.closest('[data-unit-set]');
          if (!swatch || swatch.tagName === 'SELECT') { return; }
          var index = parseInt(swatch.getAttribute('data-unit-set'), 10);
          selections[index][swatch.getAttribute('data-option')] = swatch.getAttribute('data-value');
          renderUnits();
          if (index === 0) { syncGallery(); }
          syncButton();
          syncStock();
        });
        unitHost.addEventListener('change', function (event) {
          var select_ = event.target.closest('select[data-unit-set]');
          if (!select_) { return; }
          var index = parseInt(select_.getAttribute('data-unit-set'), 10);
          selections[index][select_.getAttribute('data-option')] = select_.value;
          syncButton();
          syncStock();
        });
      }

      selections = [defaultsFor()];
      var initial = offers.filter(function (o) { return o.classList.contains('is-selected'); })[0] || offers[0];
      if (initial) { select(initial); }
      /* select() solo sincroniza unidades y botón. Sin esto la galería del color
         por defecto no se aplica y la imagen principal queda sin resolver hasta
         que el usuario toca un swatch. */
      syncGallery();
    });
  }

  /* ------------------------------------------------------ acordeones/FAQ */
  function initAccordions() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-accordion-trigger]');
      if (!trigger) { return; }
      var item = trigger.closest('[data-accordion-item]');
      if (!item) { return; }
      var wasOpen = item.classList.contains('is-open');
      var group = item.closest('[data-accordion]');
      if (group && group.getAttribute('data-accordion') === 'single') {
        $$('[data-accordion-item]', group).forEach(function (i) { i.classList.remove('is-open'); });
      }
      item.classList.toggle('is-open', !wasOpen);
      trigger.setAttribute('aria-expanded', String(!wasOpen));
    });
  }

  /* ----------------------------------------- tabs problema / solución (mobile) */
  function initTabs() {
    $$('[data-tabs]').forEach(function (group) {
      $$('[data-tab]', group).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var name = btn.getAttribute('data-tab');
          $$('[data-tab]', group).forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          $$('[data-tab-panel]', group).forEach(function (panel) {
            panel.classList.toggle('is-active', panel.getAttribute('data-tab-panel') === name);
          });
        });
      });
    });
  }

  /* ------------------------------------------------------- menú mobile */
  function initMobileMenu() {
    var toggle = $('[data-menu-toggle]');
    var menu = $('[data-mobile-menu]');
    if (!toggle || !menu) { return; }
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      $$('[data-menu-icon]', toggle).forEach(function (icon) {
        icon.hidden = icon.getAttribute('data-menu-icon') !== (open ? 'close' : 'open');
      });
    });
  }

  /* ------------------------------------------------------ copiar cupones */
  function initCopyButtons() {
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-copy]');
      if (!btn) { return; }
      var code = btn.getAttribute('data-copy');
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () {
          toast('¡Código copiado!', 'success');
          var label = $('[data-copy-label]', btn);
          if (label) {
            var original = label.textContent;
            label.textContent = 'OK';
            setTimeout(function () { label.textContent = original; }, 1800);
          }
        }).catch(function () {
          toast('No se pudo copiar. Copialo manualmente.', 'error');
        });
      } else {
        toast('No se pudo copiar. Copialo manualmente.', 'error');
      }
    });
  }

  /* --------------------------------------- carrusel de reseñas (bloque stock) */
  function initReviewCarousels() {
    $$('[data-review-carousel]').forEach(function (carousel) {
      var slides = $$('[data-review-slide]', carousel);
      if (slides.length < 2) { return; }
      var index = 0;

      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      }

      var timer = setInterval(function () { show(index + 1); }, 4500);

      $$('[data-review-prev]', carousel).forEach(function (b) {
        b.addEventListener('click', function () { clearInterval(timer); show(index - 1); });
      });
      $$('[data-review-next]', carousel).forEach(function (b) {
        b.addEventListener('click', function () { clearInterval(timer); show(index + 1); });
      });

      show(0);
    });
  }

  /* ------------------------------------------------ contador de descuento */
  /* Ventana evergreen: el fin se guarda en localStorage con una key por
     producto, así el contador no se reinicia al navegar entre secciones. Al
     llegar a cero abre una ventana nueva (misma lógica que el export). Si
     localStorage no está disponible (modo privado), el contador igual corre:
     la ventana arranca de nuevo en cada carga. */
  function initCountdown() {
    $$('[data-countdown]').forEach(function (node) {
      var clock = $('[data-countdown-clock]', node);
      if (!clock) { return; }

      var hours = parseInt(node.getAttribute('data-countdown-hours'), 10) || 24;
      var span = hours * 3600 * 1000;
      var key = 'calmax-countdown-' + (node.getAttribute('data-countdown-key') || 'default');

      function openWindow() {
        var end = Date.now() + span;
        try { localStorage.setItem(key, String(end)); } catch (e) { /* sin storage */ }
        return end;
      }

      var stored = 0;
      try { stored = parseInt(localStorage.getItem(key), 10) || 0; } catch (e) { stored = 0; }
      var end = stored > Date.now() ? stored : openWindow();

      function pad(n) { return n < 10 ? '0' + n : String(n); }

      function tick() {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) {
          end = openWindow();
          left = Math.floor(span / 1000);
        }
        clock.textContent =
          pad(Math.floor(left / 3600)) + ':' +
          pad(Math.floor((left % 3600) / 60)) + ':' +
          pad(left % 60);
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  /* ------------------------------------------------- urgencia social viva */
  function initSocialUrgency() {
    $$('[data-social-urgency]').forEach(function (node) {
      var out = $('[data-social-urgency-count]', node);
      if (!out) { return; }
      var count = 12 + Math.floor(Math.random() * 14);
      out.textContent = count + ' personas';
      setInterval(function () {
        count = Math.min(32, Math.max(11, count + (Math.floor(Math.random() * 5) - 2)));
        out.textContent = count + ' personas';
      }, 18000);
    });
  }

  /* ------------------------------------------------------ sticky CTA mobile */
  function initStickyCTA() {
    var sticky = $('[data-sticky-cta]');
    if (!sticky) { return; }
    var target = document.getElementById('variant-selector');
    if (!target) { sticky.remove(); return; }

    document.body.classList.add('has-sticky-cta');
    sticky.classList.add('is-visible');

    var observer = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0.3 });
    observer.observe(target);

    $$('[data-scroll-to]', sticky).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var el = document.getElementById(btn.getAttribute('data-scroll-to'));
        if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });
    });
  }

  function initScrollButtons() {
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-scroll-to]');
      if (!btn || btn.closest('[data-sticky-cta]')) { return; }
      var el = document.getElementById(btn.getAttribute('data-scroll-to'));
      if (el) {
        event.preventDefault();
        el.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  /* -------------------------------------------------------- video en vista */
  function initVideos() {
    $$('[data-autoplay-video]').forEach(function (video) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          var p = video.play();
          if (p && p.catch) { p.catch(function () {}); }
        } else {
          video.pause();
        }
      }, { threshold: 0.3 });
      observer.observe(video);
    });
  }

  /* ------------------------------------------------------- modales genéricos */
  function initModals() {
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-modal-open]');
      if (opener) {
        event.preventDefault();
        var modal = document.getElementById(opener.getAttribute('data-modal-open'));
        if (modal) { modal.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
        return;
      }
      var closer = event.target.closest('[data-modal-close]');
      if (closer || event.target.classList.contains('modal')) {
        var open = $('.modal.is-open');
        if (open) { open.classList.remove('is-open'); document.body.style.overflow = ''; }
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') { return; }
      var open = $('.modal.is-open');
      if (open) { open.classList.remove('is-open'); document.body.style.overflow = ''; }
    });
  }

  /* --------------------------------------------- exit intent (una vez por sesión) */
  function initExitIntent() {
    var modal = $('[data-exit-modal]');
    if (!modal) { return; }
    var STORAGE_KEY = 'calmax_exit_intent_shown';
    try { if (sessionStorage.getItem(STORAGE_KEY)) { return; } } catch (e) { return; }

    var triggered = false;
    function trigger() {
      if (triggered) { return; }
      triggered = true;
      try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
      modal.classList.add('is-open');
    }

    function onMouseOut(e) {
      if (e.clientY <= 0 && !e.relatedTarget) { trigger(); }
    }

    var lastY = window.scrollY;
    var inactivityTimer = null;
    function onScrollUp() {
      var y = window.scrollY;
      if (lastY - y > 80 && y < 200) {
        document.removeEventListener('scroll', onScrollUp);
        trigger();
      }
      lastY = y;
    }
    function resetInactivity() {
      if (inactivityTimer) { clearTimeout(inactivityTimer); }
      inactivityTimer = setTimeout(function () {
        document.addEventListener('scroll', onScrollUp, { passive: true });
      }, 90000);
    }
    function onInteract() { lastY = window.scrollY; resetInactivity(); }

    document.addEventListener('mouseout', onMouseOut);
    document.addEventListener('touchstart', onInteract, { passive: true });
    document.addEventListener('scroll', onInteract, { passive: true });
    resetInactivity();

    $$('[data-exit-close]', modal).forEach(function (btn) {
      btn.addEventListener('click', function () { modal.classList.remove('is-open'); });
    });
    modal.addEventListener('click', function (event) {
      if (event.target === modal) { modal.classList.remove('is-open'); }
    });
  }

  /* ---------------------------------------- aparición suave de secciones */
  function initReveal() {
    var nodes = $$('[data-reveal]');
    if (!nodes.length) { return; }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });
    nodes.forEach(function (n) {
      n.style.opacity = '0';
      n.style.transition = 'opacity .7s ease';
      observer.observe(n);
    });
  }

  /* --------------------------------------------------- guía de talles */
  /* El <select> ya trae el talle base como `value`; el calce solo corre
     ese talle N escalones dentro de la escala configurada. */
  function initSizeGuide() {
    $$('[data-size-guide]').forEach(function (guide) {
      var select = $('[data-size-guide-shoe]', guide);
      var result = $('[data-size-guide-result]', guide);
      var fits = $$('[data-size-guide-fit]', guide);
      var scaleNode = $('[data-size-guide-scale]', guide);
      if (!select || !result || !scaleNode) { return; }

      var scale = [];
      try { scale = JSON.parse(scaleNode.textContent) || []; } catch (e) { scale = []; }
      if (!scale.length) { return; }

      var shift = 0;

      function update() {
        var index = scale.indexOf(select.value);
        if (index < 0) { index = 0; }
        index = Math.min(Math.max(index + shift, 0), scale.length - 1);
        result.textContent = scale[index];
      }

      select.addEventListener('change', update);

      fits.forEach(function (button) {
        button.addEventListener('click', function () {
          fits.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
          });
          button.classList.add('is-active');
          button.setAttribute('aria-pressed', 'true');
          shift = parseInt(button.getAttribute('data-size-guide-fit'), 10) || 0;
          update();
        });
      });

      update();
    });
  }

  function init() {
    initGallery();
    initOffers();
    initAccordions();
    initTabs();
    initMobileMenu();
    initCopyButtons();
    initReviewCarousels();
    initSizeGuide();
    initCountdown();
    initSocialUrgency();
    initStickyCTA();
    initScrollButtons();
    initVideos();
    initModals();
    initExitIntent();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
